import ProxyBase from '../../../../core/proxies/ProxyBase'

class AlertProxy extends ProxyBase {
  getAlertHighlight(params) {
    return this.get('Alert/AlertHightLight', params, undefined, true)
  }
}

export default new AlertProxy()
